import { trackGTMEvent } from '@air/marketing-analytics';
import { chilipiperEmailValidationSchema } from '@air/plasmic-chilipiper';
import { Box, BoxProps, Button, Input as DeprecatedInput } from '@air/zephyr';
import { Formik } from 'formik';
import { useState } from 'react';
import { object } from 'yup';

import { Form } from '~/old-marketing/components/Form';

const validationSchema = object({
  email: chilipiperEmailValidationSchema,
});

const addToSpreadsheet = async (values: { email: string; type: 'Adobe Premiere Pro' }) => {
  const response = await fetch('https://sheetdb.io/api/v1/q0uukn89582fl', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(values),
  });

  return response.json();
};

export const AdobeWaitlistForm = ({ tx }: Pick<BoxProps, 'tx'>) => {
  const [hasSubmitted, setHasSubmitted] = useState(false);

  return (
    <Formik
      initialValues={validationSchema.cast(undefined)!}
      onSubmit={async (values) => {
        const response = await addToSpreadsheet({ ...values, type: 'Adobe Premiere Pro' });

        if (response.created === 1) {
          setHasSubmitted(true);
        }

        trackGTMEvent({
          event: 'Adobe Waitlist',
          eventProps: { label: 'adobe waitlist', category: 'gated' },
        });
      }}
      validationSchema={validationSchema}
    >
      {({ isSubmitting }) => (
        <Form>
          <Box tx={{ display: 'flex', flexDirection: ['column', 'row'], alignItems: 'center', ...tx }}>
            <DeprecatedInput
              autoComplete="email"
              disabled={hasSubmitted}
              isLabelHidden
              label="Email"
              name="email"
              placeholder="Enter your work email"
              required
              tx={{ flexGrow: 1, minWidth: 'unset', width: ['100%', 'auto'] }}
              type="email"
              variant="field-input-chonky"
            />
            <Button
              disabled={hasSubmitted}
              isLoading={isSubmitting}
              size="large"
              type="submit"
              tx={{ width: ['100%', 'auto'], mt: [16, 0], ml: [0, 16] }}
            >
              {hasSubmitted ? 'Success!' : 'Join the waitlist'}
            </Button>
          </Box>
        </Form>
      )}
    </Formik>
  );
};
